import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import type { TriggerProps } from '../dropdown.types';
const Trigger = forwardRef<HTMLButtonElement, TriggerProps>((t0, ref) => {
  const $ = _c(27);
  let ariaLabel;
  let children;
  let hasChevron;
  let inline;
  let maxWidth;
  let minWidth;
  let props;
  let width;
  if ($[0] !== t0) {
    const {
      children: t1,
      width: t2,
      height,
      maxWidth: t3,
      minWidth: t4,
      hasChevron: t5,
      ariaLabel: t6,
      inline: t7,
      ...t8
    } = t0;
    children = t1;
    width = t2;
    maxWidth = t3;
    minWidth = t4;
    hasChevron = t5;
    ariaLabel = t6;
    inline = t7;
    props = t8;
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = children;
    $[3] = hasChevron;
    $[4] = inline;
    $[5] = maxWidth;
    $[6] = minWidth;
    $[7] = props;
    $[8] = width;
  } else {
    ariaLabel = $[1];
    children = $[2];
    hasChevron = $[3];
    inline = $[4];
    maxWidth = $[5];
    minWidth = $[6];
    props = $[7];
    width = $[8];
  }
  const t1 = inline ? "inline-flex" : "flex";
  let t2;
  if ($[9] !== t1) {
    t2 = cx(t1, "cursor-pointer group items-center gap-2", "focus:outline-none", "focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary", "data-[disabled]:cursor-auto data-[disabled]:select-none data-[disabled]:hover:bg-transparent");
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = width || "fit-content";
  let t4;
  if ($[11] !== maxWidth || $[12] !== minWidth || $[13] !== t3) {
    t4 = {
      width: t3,
      maxWidth,
      minWidth
    };
    $[11] = maxWidth;
    $[12] = minWidth;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== hasChevron) {
    t5 = hasChevron && <div className="flex items-center w-full justify-center group-data-[state=open]:rotate-180 origin-center group-data-[state=closed]:rotate-0 transition-transform duration-200 group-data-[disabled]:opacity-40 group-data-[disabled]:cursor-auto"><IcoChevronDown16 /></div>;
    $[15] = hasChevron;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== ariaLabel || $[18] !== children || $[19] !== t2 || $[20] !== t4 || $[21] !== t5) {
    t6 = <div aria-label={ariaLabel} className={t2} style={t4}>{children}{t5}</div>;
    $[17] = ariaLabel;
    $[18] = children;
    $[19] = t2;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== props || $[24] !== ref || $[25] !== t6) {
    t7 = <RadixDropdown.Trigger {...props} ref={ref} asChild={true}>{t6}</RadixDropdown.Trigger>;
    $[23] = props;
    $[24] = ref;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
});
export default Trigger;